var _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShahid(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "900px",
    height: "255px",
    viewBox: "0 0 901 255",
    id: "svg5",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs5"
  })), /*#__PURE__*/React.createElement("g", {
    id: "surface1"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(0%,82.745098%,34.509804%)",
      fillOpacity: 1
    },
    d: "M 596.667969 86.929688 C 596.667969 106.960938 612.898438 123.132812 632.871094 123.132812 C 652.84375 123.132812 669.070312 106.90625 669.070312 86.929688 C 669.070312 66.957031 652.84375 50.730469 632.871094 50.730469 C 612.898438 50.730469 596.667969 66.957031 596.667969 86.929688 Z M 596.667969 86.929688 ",
    id: "path1"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(0%,80%,60%)",
      fillOpacity: 1
    },
    d: "M 712.59375 86.929688 C 712.59375 106.960938 728.820312 123.132812 748.792969 123.132812 C 768.769531 123.132812 784.996094 106.90625 784.996094 86.929688 C 784.996094 66.957031 768.769531 50.730469 748.792969 50.730469 C 728.820312 50.730469 712.59375 66.957031 712.59375 86.929688 Z M 712.59375 86.929688 ",
    id: "path2"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(0%,60%,100%)",
      fillOpacity: 1
    },
    d: "M 828.511719 86.929688 C 828.511719 106.960938 844.738281 123.132812 864.714844 123.132812 C 884.6875 123.132812 900.914062 106.90625 900.914062 86.929688 C 900.914062 66.957031 884.6875 50.730469 864.714844 50.730469 C 844.738281 50.730469 828.511719 66.957031 828.511719 86.929688 Z M 828.511719 86.929688 ",
    id: "path3"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "#ffffff",
      fillOpacity: 1
    },
    d: "M 553.199219 173.859375 L 553.199219 0 L 495.207031 0 L 495.207031 231.847656 L 842.980469 231.847656 L 842.980469 255 L 900.972656 255 L 900.972656 173.859375 Z M 553.199219 173.859375 ",
    id: "path4"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "#ffffff",
      fillOpacity: 1
    },
    d: "M 104.765625 154.28125 L 104.765625 173.859375 L 0.0195312 173.859375 L 0.0195312 231.847656 L 451.804688 231.847656 L 451.804688 117.515625 C 451.804688 68.601562 412.027344 28.824219 363.113281 28.824219 C 336.558594 28.824219 308.980469 41.820312 294.570312 64.402344 C 224.890625 63.210938 191.414062 117.96875 212.632812 173.914062 L 162.871094 173.914062 L 162.871094 146.851562 C 162.871094 129.488281 160.089844 117.683594 153.339844 104.066406 C 130.074219 57.082031 78.097656 38.472656 16.304688 60.261719 L 16.304688 113.597656 C 43.371094 104.464844 104.824219 89.199219 104.824219 154.28125 Z M 285.546875 117.117188 C 301.207031 117.117188 313.917969 129.882812 313.917969 145.488281 L 313.917969 173.859375 L 285.546875 173.859375 C 269.886719 173.859375 257.175781 161.148438 257.175781 145.488281 C 257.175781 129.828125 269.945312 117.117188 285.546875 117.117188 Z M 367.257812 173.914062 L 367.257812 144.695312 C 367.257812 122.5625 358.914062 102.308594 345.296875 86.929688 C 350.519531 83.867188 356.589844 82.105469 363.058594 82.105469 C 382.578125 82.105469 398.410156 97.996094 398.410156 117.457031 L 398.410156 173.859375 L 367.257812 173.859375 Z M 367.257812 173.914062 ",
    id: "path5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShahid);
export default __webpack_public_path__ + "static/media/shahid.75c50f57950f7c76c45b03d43d0a84b1.svg";
export { ForwardRef as ReactComponent };